<template>
    <div >
        <div v-for="record in recordsTabulated">
            <div class="row no-wrap">
                <div>Respondent Key: <strong>{{ record.primaryKey }}</strong></div>&nbsp;
                <div>SourceSystem: <strong>{{ record.location.sourceSystem }}</strong></div>&nbsp;
                <div>Database: <strong>{{ record.location.database }}</strong></div>&nbsp;
                <div>Table: <strong>{{ record.location.table }}</strong></div>
            </div>
            <q-table :columns="columns"
                          :rows="record.tableData">
            </q-table>
        </div>
    </div>
</template>

<script type="javascript">

    export default {
        name: 'formatted-request',
        components: {},
        props: [
            'records'
        ],
        data() {
            return {
                columns: [
                    {
                        label: 'Variable',
                        field: 'variable'
                    },
                    {
                        label: 'Operation',
                        field: 'description'
                    }
                ]
            };
        },
        computed: {
            recordsTabulated() {
                return _.map(this.records, ({location, operations, primaryKey }) => {
                    const tableData = [];
                    _.forOwn(operations, (operation, variable) => {
                        let description = 'UNKNOWN OPERATION';
                        const {op, param} = operation;
                        if (op === 'modify') {
                            description = `SET TO ${param}`;
                        }
                        if (op === 'nullify') {
                            description = 'SET TO NULL';
                        }
                        tableData.push({
                            variable,
                            description
                        });
                    });
                    return {
                        primaryKey,
                        location,
                        tableData
                    };
                });
            }
        }
    };
</script>
